(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-silver"] && !Shopify.designMode) return;
  try {
    
function initVelora(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const cards=Array.from(root.querySelectorAll('[data-card]'));
  const models=new Set();
  cards.forEach(card=>{
    const master=card.querySelector('[data-variant]');
    const choices=Array.from(card.querySelectorAll('[data-option]')).sort((a,b)=>Number(a.dataset.option)-Number(b.dataset.option));
    const variants=Array.from(master.options).map(o=>({element:o,options:JSON.parse(o.dataset.options)}));
    const modelIndex=variants[0]?.options.findIndex(v=>/iphone/i.test(v))??-1;
    card.models=modelIndex<0?[]:Array.from(new Set(variants.filter(v=>v.element.dataset.available==='true').map(v=>v.options[modelIndex])));
    card.models.forEach(m=>models.add(m));
    const button=card.querySelector('[data-add]');
    function syncAvailableFinishes(){
      const model=modelIndex<0?'':choices[modelIndex].value;
      choices.forEach((choice,i)=>{
        if(i===modelIndex)return;
        Array.from(choice.options).forEach(option=>{
          option.disabled=!variants.some(v=>v.element.dataset.available==='true'&&v.options[i]===option.value&&(modelIndex<0||v.options[modelIndex]===model));
        });
        if(choice.selectedOptions[0]?.disabled){
          const first=Array.from(choice.options).find(o=>!o.disabled);
          if(first)choice.value=first.value;
        }
      });
    }
    function update(changeImage=true){
      syncAvailableFinishes();
      const match=variants.find(v=>v.options.every((x,i)=>x===choices[i].value));
      const o=match?.element;
      master.value=o?o.value:'';
      const available=o?.dataset.available==='true';
      button.disabled=!available;
      button.querySelector('[data-add-text]').textContent=o?(available?button.dataset.addLabel:button.dataset.soldLabel):button.dataset.unavailableLabel;
      card.querySelector('[data-price-label]').textContent=o?o.dataset.price:button.dataset.unavailableLabel;
      if(o){
        const img=card.querySelector('.vs-product-image');
        if(changeImage&&img&&o.dataset.image){img.classList.add('is-variant');img.removeAttribute('srcset');img.src=o.dataset.image;img.alt=card.querySelector('h3').textContent+' — '+match.options.join(' / ');}
        const link=card.querySelector('[data-detail]');
        const url=new URL(link.href);url.searchParams.set('variant',o.value);link.href=url.href;
      }
    }
    const selected=variants.find(v=>v.element.selected&&v.element.dataset.available==='true')||variants.find(v=>v.element.dataset.available==='true')||variants[0];
    choices.forEach((c,i)=>{c.value=selected.options[i];c.addEventListener('change',update)});
    card.querySelector('.vs-fallback').hidden=true;
    card.querySelector('[data-options]').hidden=false;
    update(false);
  });
  const filter=root.querySelector('[data-filter]');
  Array.from(models).sort().forEach(m=>{const o=document.createElement('option');o.value=m;o.textContent=m;filter.append(o)});
  filter.addEventListener('change',()=>{cards.forEach(c=>c.hidden=!!filter.value&&!c.models.includes(filter.value));root.querySelector('[data-empty]').hidden=cards.some(c=>!c.hidden)});
  root.querySelector('[data-sort]').addEventListener('change',e=>{const direction=e.target.value;const sorted=cards.slice().sort((a,b)=>direction==='featured'?Number(a.dataset.order)-Number(b.dataset.order):(Number(a.dataset.price)-Number(b.dataset.price))*(direction==='low'?1:-1));sorted.forEach(c=>root.querySelector('[data-grid]').append(c))});
  const requestedModel=new URLSearchParams(window.location.search).get('vs_model');
  if(requestedModel&&models.has(requestedModel)){filter.value=requestedModel;filter.dispatchEvent(new Event('change'));}
  root.querySelector('[data-tools]').hidden=false;
}
document.querySelectorAll('[data-velora]').forEach(initVelora);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-velora]').forEach(initVelora));

  } catch(e) { console.error(e); }
})();
})();
